<template>
  <div>
    <div class="mdgridviewpage-bg homenewbgdata">
      <training-header></training-header>
      <div class="container-fluid m-t-10px">
        <div class="row dashboardchart-container globalconfigcontainer">
          <div class="col-xs-12 col-sm-7 d-block d-sm-block d-md-none m-auto">
            <img src="../assets/img/info_pic.png" class="img-fluid" style />
          </div>
          <div class="col-lg-7 col-sm-7 col-xs-12 formDiv" style>
            <div class="card m-b-20px m-t-20px cardDiv">
              <ValidationObserver v-slot="{ handleSubmit }">
                <div class="collapse show" aria-labelledby="headingOne">
                  <div class="card-body c-body p-40px">
                    <form @submit.prevent="handleSubmit(onSubmit)" class="d-flex">
                      <div class="col-lg-6" style="margin: 0 auto;">
                        <div class="mainform-holder w-100" style="padding-top: 10px;">
                          <h4
                            class="inner-heading text-center pt-2 pb-1 w-100 mb-4"
                            style="font-weight: 400; margin-bottom:0px;"
                          >
                            <i class="fa fa-user mr-2" aria-hidden="true"></i> Request for Registration
                          </h4>

                          <div class="col-lg-12 mb-1">
                            <div class="form-group row">
                              <div class="col-6 px-1">
                                <ValidationProvider
                                  name="Firstname"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <input
                                    v-model.trim="frmAccount['firstname']"
                                    type="text"
                                    class="form-control bg-grey"
                                    placeholder="First Name"
                                  />
                                  <span class="text-danger">{{ errors[0] }}</span>
                                </ValidationProvider>
                              </div>
                              <div class="col-6 px-1">
                                <ValidationProvider
                                  name="Last Name"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <input
                                    v-model.trim="frmAccount['lastname']"
                                    type="text"
                                    class="form-control bg-grey"
                                    placeholder="Last Name"
                                  />
                                  <span class="text-danger">{{ errors[0] }}</span>
                                </ValidationProvider>
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-12 mb-1">
                            <div class="form-group row">
                              <div class="col-6 px-1">
                                <div class="">
                                  <select
                                    class="form-control"
                                    id="country"
                                    name="country"
                                    v-model="nationality"
                                    @change="getNation"
                                    :disabled="ndisabled == 0"
                                  >
                                    <option value>Select Nationality</option>
                                    <option
                                      v-for="c in countries"
                                      :key="c.Code+'-'+c.Name"
                                      :value="c.Code+'-'+c.Name"
                                    >{{c.Name}}</option>
                                  </select>
                                  <span
                                    v-if="isActive"
                                    v-bind:class="{ active: isActive, 'text-danger': hasError }"
                                    class="text-danger"
                                  >This field is required</span>
                                </div>
                              </div>
                              <div class="col-6 px-1">
                                <input
                                  class="form-control"
                                  placeholder="If Other, Please Specify"
                                  v-model="otherNationality"
                                  :disabled="odisabled == 1"
                                  @blur="getOther"
                                />
                                <span
                                  v-if="isActive"
                                  v-bind:class="{ active: isActive, 'text-danger': hasError }"
                                  class="text-danger"
                                >This field is required</span>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-12 mb-1">
                            <div class="form-group row">
                              <div class="col-sm-12" v-if="odisabled == 0">
                                <ValidationProvider
                                  name="User Name"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <input
                                    v-model.trim="frmAccount['mobile']"
                                    type="number"
                                    class="form-control bg-grey"
                                    placeholder="Mobile Number"
                                  />
                                  <span class="text-danger">{{ errors[0] }}</span>
                                </ValidationProvider>
                              </div>
                              <div class="col-sm-12" v-else>
                                <VuePhoneNumberInput
                                  color="#dc3545"
                                  v-model="phoneNumber"
                                  :default-country-code="nationality.split('-')[0]"
                                  @update="results = JSON.stringify($event)"
                                />
                                <span
                                  v-if="results && !JSON.parse(results).isValid"
                                  class="text-danger"
                                >Please enter valid number</span>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-12 mb-1">
                            <div class="form-group row">
                              <div class="col-sm-12">
                                <div class="">
                                  <select class="form-control" id="country" name="country" v-model="frmAccount['userRole']">
                                    <option value="">Select User Role</option>
                                    <option v-for="r in userRoles" :key="r.id" :value="r.id">{{r.displayName}}</option>
                                  </select>
                                  <span v-if="isActive" v-bind:class="{ active: isActive, 'text-danger': hasError }" class="text-danger">This field is required</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-12 mb-1">
                            <div class="form-group row">
                              <div class="col-sm-12">
                                <input class="form-control" placeholder="Location Access" v-model="frmAccount['comment']">
                                <span v-if="isActive" v-bind:class="{ active: isActive, 'text-danger': hasError }" class="text-danger">This field is required</span>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-12 mb-1">
                            <div class="form-group row">
                              <div class="col-sm-12">
                                <ValidationProvider
                                  name="Email"
                                  rules="required|email"
                                  v-slot="{ errors }"
                                >
                                  <input
                                    v-model="frmAccount['email']"
                                    type="email"
                                    class="form-control bg-grey"
                                    placeholder="Email"
                                    autocomplete="new-nemail"
                                  />
                                  <span class="text-danger">{{ errors[0] }}</span>
                                </ValidationProvider>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-12 mb-1">
                            <div class="form-group row">
                              <div class="col-6 px-1">
                                <ValidationProvider
                                  name="Password"
                                  rules="required|verify_password|min:8|max:16"
                                  v-slot="{ errors }"
                                  vid="confirmation"
                                >
                                  <div class="input-group">
                                    <input
                                      v-model="frmAccount['password']"
                                      type="password"
                                      class="form-control bg-grey"
                                      placeholder="Password"
                                      id="password"
                                      autocomplete="new-paaaassword"
                                    />
                                    <div class="input-group-append">
                                      <span
                                        @click="showPass"
                                        class="input-group-text fa fa-eye bg-grey"
                                      ></span>
                                    </div>
                                  </div>
                                  <span class="text-danger">{{ errors[0] }}</span>
                                </ValidationProvider>
                              </div>
                              <div class="col-6 px-1">
                                <ValidationProvider
                                  name="Confirm Password"
                                  rules="required|confirmed:confirmation"
                                  v-slot="{ errors }"
                                >
                                  <input
                                    v-model="frmAccount['confirm_pass']"
                                    type="password"
                                    class="form-control bg-grey"
                                    placeholder="Confirm Password"
                                  />
                                  <span class="text-danger">{{ errors[0] }}</span>
                                </ValidationProvider>
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-12 mb-3">
                            <div class="row mb-4">
                              <div class="col-12">
                                <div class="form-group row mb-0">
                                  <div class="col-sm-12 text-left">
                                    <button
                                      type="submit"
                                      class="btn btn-primary black-btn color-white btn-block"
                                      style="padding: 6px 35px; border-radius:50px;"
                                    >Request</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-6">
                                <div class="form-group row mb-0">
                                  <div
                                    class="col-sm-12 text-center"
                                    style="border-right: 1px solid #797979;"
                                  >
                                    <a class @click="GotoSignin()" style="font-size: 14px;">Sign In</a>
                                  </div>
                                </div>
                              </div>

                              <div class="col-6">
                                <div class="form-group row mb-0">
                                  <div class="col-sm-12 text-center">
                                    <a
                                      class
                                      @click="goToActivateAccount"
                                      style="font-size: 14px; color: #797979;"
                                    >Activate Account</a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
      <training-footer></training-footer>
    </div>
  </div>
</template>

<script>
import { extend } from "vee-validate";
import ApiServices from "../service/ApiServices";
import trainingHeader from "../components/trainingHeader";
import trainingFooter from "../components/trainingFooter";
import $ from "jquery";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import country from './countries.js'

//Vue.component('vue-phone-number-input', VuePhoneNumberInput);

//password restrictions
extend("verify_password", {
  message: `The {_field_} must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character`,
  validate: value => {
    var strongRegex = new RegExp(
      "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
    );
    return strongRegex.test(value);
  }
});
export default {
  props: {},
  components: {
    trainingHeader,
    trainingFooter,
    VuePhoneNumberInput
  },
  data() {
    return {
      frmAccount: {
        firstname: "",
        lastname: "",
        email: "",
        mobile: "",
        password: "",
        confirm_pass: "",
        nationality: "",
        userRole: "",
        comment: "",
        status: "Incomplete"
      },
      userRoles: [],
      otherNationality: "",
      nationality: "",
      settings: settings,
      countries: country.countryList(),
      odisabled: 0,
      ndisabled: 1,
      isActive: false,
      hasError: false,
      results: null,
      phoneNumber: ""
    };
  },
  methods: {
    getNation() {
      if (this.nationality == "") {
        this.isActive = true;
        this.hasError = true;
        this.odisabled = 0;
      } else {
        this.odisabled = 1;
        this.isActive = false;
        this.hasError = false;
      }
    },
    getOther() {
      if (this.otherNationality == "") {
        this.ndisabled = 1;
        this.isActive = true;
        this.hasError = true;
      } else {
        this.ndisabled = 0;
        this.isActive = false;
        this.hasError = false;
      }
    },
    showPass() {
      let passwordField = document.querySelector("#password");
      if (passwordField.getAttribute("type") === "password") {
        passwordField.setAttribute("type", "text");
      } else {
        passwordField.setAttribute("type", "password");
      }
    },
    GotoSignin() {
      this.$router.push("/");
    },
    goToActivateAccount() {
      this.$router.push("/activate");
    },
    onSubmit() {
      //this.$root.loading = true;
      if (!this.isActive) {
        if (this.otherNationality != "") {
          this.frmAccount["nationality"] = this.otherNationality;
        } else {
          this.frmAccount["nationality"] = this.nationality;
        }
        if (this.otherNationality == "") {
          this.phoneNumber = JSON.parse(this.results)["formatInternational"];
          this.frmAccount["mobile"] = this.phoneNumber;
        }
        console.log(this.frmAccount, this.nationality);
        let headers = { Authorization: "Basic YWRtaW46ZGlzdHJpY3Q=" };
        ApiServices.RestPostCall(
          "api/avenir/register/request",
          this.frmAccount
        )
          .then(Response => {
            this.$root.loading = false;
            if (Response.status && Response.status.toLowerCase() == "success") {
              this.$swal({
                text: Response.message
              }).then(() => {
                this.$router.push("/activate");
              });
            } else {
              this.$swal({
                text: Response.message
              });
            }
          })
          .catch(error => {
            this.$root.loading = false;
            this.$swal({
              text: error
            });
          });
      }
    },
    getUserRoles() {
      ApiServices.RestGetCall('api/userRoles?fields=displayName%2Cid%2C&order=name%3Aasc').then(response => {
        console.log("user roles", response)
        this.userRoles = response.userRoles
      })
    }
  },
  mounted() {
    this.getUserRoles()
  },
  updated() {}
};
</script>

<style lang="scss" scoped>
</style>
